import { FC, memo, useContext, useEffect, useState } from 'react'
import styles from './index.module.less'
import { ILoginFormProps } from './const'
import { EyeInvisibleOutlined, EyeOutlined, LockOutlined, UserOutlined } from '@ant-design/icons'
import globalContext from '~/contexts/global.context'
import { useLocation, useHistory } from 'react-router-dom'
import { api } from '~/request'
import { ECodeScene } from '~/enums/ECodeScene'
import { isMobilePhone } from '~/modules/@xy/backend-pro/src/utils/validator'
import { Input, Button, Form } from 'antd'
import { defaultPwd } from '~/config'
import { encryptPassword } from '../../const'
import {getMenus} from '~/routes'
const { Item, useForm } = Form

const Component: FC<ILoginFormProps> = (props) => {
  const { dispatchAction, dispatch } = useContext(globalContext)
  const { state } = useLocation<{ from?: string }>()
  const history = useHistory()
  const [form] = useForm()

  const [passwordType, setPasswordType] = useState('password')

  useEffect(() => {
    // form.setFieldsValue({ mobile: '19999999999', password: defaultPwd })
  }, [])

  function handleFinish() {
    form.validateFields().then(async () => {
      const { mobile, password } = form.getFieldsValue()
      const encrypted = encryptPassword(password)

      const { data } = await api['/xinxuan/console/public/login_POST']({ mobile, password: encrypted })
      window.localStorage.setItem('Authorization', data || '')
      await dispatchAction('getUserInfo')
      localStorage.setItem('historyParamsData', '')
      // 获取用户权限
      const res = await api['/xinxuan/console/console/sysUser/current-authorities_GET']()
      if (res.data) {
        const { buttons = [], menusTree = [], username } = res.data
        console.log(menusTree, 'menusTree')
        const authCodes: string[] = buttons.map((item) => item.code)
        // const menus = [];
        dispatch({
          authCodes,
          name: username,
          menus: menusTree
          // menus: menusTree.length > 0 ? menusTree : getMenus()
        })
      }
      if (state && state.from) {
        history.replace(state.from)
      } else {
        history.replace('/')
      }
    })
  }

  return (
    <Form labelCol={{ span: 6 }} labelAlign="left" form={form} onFinish={handleFinish}>
      <Item
        name="mobile"
        validateFirst
        rules={[
          { required: true, message: '请输入手机号码' },
          { validator: (_, value) => (isMobilePhone(value) ? Promise.resolve() : Promise.reject(new Error('请输入正确的手机号码'))) }
        ]}
      >
        <Input placeholder="请输入手机号码" maxLength={11} size="large" prefix={<UserOutlined style={{ color: '#bfbfbf' }} />} />
      </Item>
      <Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
        <Input
          placeholder="请输入密码"
          size="large"
          prefix={<LockOutlined style={{ color: '#bfbfbf' }} />}
          type={passwordType}
          suffix={
            passwordType === 'password' ? (
              <EyeInvisibleOutlined onClick={() => setPasswordType('text')} />
            ) : (
              <EyeOutlined onClick={() => setPasswordType('password')} />
            )
          }
        />
      </Item>

      {/* <Form.Item noStyle>
        <div className={styles.opeartions}>
          <Button type="link" onClick={() => props.onClick(ECodeScene.FORGOT)}>
            忘记密码?
          </Button>
          <Button type="link" onClick={() => props.onClick(ECodeScene.REG)}>
            前往注册
          </Button>
        </div>
      </Form.Item> */}

      <Item>
        <Button type="primary" block size="large" htmlType="submit">
          登录
        </Button>
      </Item>
    </Form>
  )
}

Component.displayName = 'LoginForm'

const LoginForm = memo(Component)
export default LoginForm
